import {IconButton, TrashIcon} from '@logistics-frontend/blocks'
import React, {useCallback} from 'react'

import type {RemoveButtonProps} from './RemoveButton.types'

export function RemoveButton({onClick, index, size = 'm', ...props}: RemoveButtonProps): React.ReactElement {
  const removeHandler = useCallback(() => {
    onClick(index)
  }, [index, onClick])

  return (
    <IconButton onPress={removeHandler} size={size} {...props}>
      <TrashIcon />
    </IconButton>
  )
}
